import { GrEdit } from "react-icons/gr";

export const getPendinOrdersShippingType = (order) => {
  if (order?.shippingInfo?.shippingType) {
    return order.shippingInfo.shippingType;
  }
  if (order?.orShipping?.type) {
    return order.orShipping.type;
  }
  return order?.shipType || "";
};

export const getCompanyName = (order) => {
  return (
    order?.shippingInfo?.labels?.[0]?.companyName ||
    order?.orShipping?.companyName ||
    order?.companyName ||
    "N/A"
  );
};

export const getEditCostStatus = (order) => {
  return order?.orCogs?.status &&
    order?.orDsFees?.status &&
    order?.orShipping?.status
    ? "Delivered"
    : "+add";
};

export const getEditCostBodyContent = (order) => {
  const completedCount = [
    order?.orCogs,
    order?.orShipping,
    order?.orDsFees,
  ].reduce((acc, obj) => (obj.status ? acc + 1 : acc), 0);

  return (
    <>
      <span>{completedCount}/3</span>
      <span>
        <GrEdit />
      </span>
      <span className="ml-2">Edit</span>
    </>
  );
};
